import React from "react";
import { CheckSquare, Download, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PackersToolbarProps {
  total: number;
  packedToday: number;
  selectedCount: number;
  newCount: number;
  onSelectAll: () => void;
  onPrintSelected: () => void;
  onPrintNew: () => void;
  onExportXml: () => void;
  isPrinting: boolean;
  isExporting?: boolean;
}

const PackersToolbar = ({
  total,
  packedToday,
  selectedCount,
  newCount,
  onSelectAll,
  onPrintSelected,
  onPrintNew,
  onExportXml,
  isPrinting,
  isExporting
}: PackersToolbarProps) => {
  return (
    <div className="flex items-center justify-between flex-wrap gap-3">
      <div className="flex items-center gap-3">
        <span className="bg-white/10 text-white px-3 py-1.5 rounded-full text-sm font-medium">
          {total} beschikbaar
        </span>
        


      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onSelectAll}
          className="bg-white/10 border-white/20 text-white hover:bg-white/20">

          <CheckSquare className="w-4 h-4 mr-1" />
          Selecteer alle
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onPrintSelected}
          disabled={selectedCount === 0 || isPrinting}
          className="bg-white/10 border-white/20 text-white hover:bg-white/20">

          <Download className="w-4 h-4 mr-1" />
          Download etiketten ({selectedCount})
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onPrintNew}
          disabled={isPrinting || newCount === 0}
          className="bg-blue-500/20 border-blue-400/30 text-blue-200 hover:bg-blue-500/30">
          <Download className="w-4 h-4 mr-1" />
          Download nieuwe ({newCount})
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onExportXml}
          disabled={selectedCount === 0 || isExporting}
          className="bg-emerald-500/20 border-emerald-400/30 text-emerald-200 hover:bg-emerald-500/30">
          <FileText className="w-4 h-4 mr-1" />
          XML Export ({selectedCount})
        </Button>
      </div>
    </div>);

};

export default PackersToolbar;